import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { getBusinessDetailPath } from '../constants/routes';
import LoadingSpinner from '../components/common/LoadingSpinner';

/**
 * Dashboard Page - Redirects to the business detail page for the user's business
 */
const DashboardPage = () => {
  const navigate = useNavigate();
  const { customerIds, isBusinessOwner } = useAuth();

  useEffect(() => {
    if (isBusinessOwner && customerIds && customerIds.length > 0) {
      // Redirect to business detail page for first customer
      const customerId = customerIds[0];
      // Use customerId as businessId and pass customerId in state
      navigate(getBusinessDetailPath(customerId), { 
        replace: true,
        state: { customerId }
      });
    } else {
      // If not a business owner, redirect to home
      navigate('/', { replace: true });
    }
  }, [isBusinessOwner, customerIds, navigate]);

  return <LoadingSpinner fullPage />;
};

export default DashboardPage;
